import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadingNotification } from '@/lib/components/LoadingNotification/LoadingNotification';
import { RouteEnum } from '@/lib/components/TopBar/routeEnum';

import { useStateFileContext } from '@/src/ContactsModule/contexts/ImportFileContext';
import { getDataCard } from '@/src/ContactsModule/contexts/ImportFileContext/DataCard';

export const StateCard = () => {
  const [showLoaderImport, setLoaderImport] = useState<boolean>(false);
  const { files } = useStateFileContext();
  const { step, percentage } = files?.importLoading ?? { step: 0, percentage: 0 };
  const dataCard = getDataCard();

  const navigate = useNavigate();

  const handler = () => {
    navigate(`v2/${RouteEnum.ContactsImport}`);
  };

  useEffect(() => {
    if (files) {
      setLoaderImport(files?.showStateCard);
    }
  }, [files]);

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] w-fit p-6">
      {showLoaderImport && dataCard && step && percentage && files?.state ? (
        <div onClick={() => handler()}>
          <LoadingNotification
            dataCard={dataCard}
            percentage={percentage}
            status={files?.state}
            step={step}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
